import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { mixrActions } from 'srcReact/Mixr/actions'
import Avatar from 'srcReact/components/common2/Avatar'
import IconButton from 'srcReact/components/common2/IconButton'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import EmojisForRating from '../EmojisForRating'
import Spinner from 'srcReact/components/common2/Spinner'

function ReviewList({ mixrId, openWriteReviewModal, isLoading }) {
  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    mixr: {
      rating: {
        data: {
          ratings_and_reviews: { user_ratings: reviewList, stats }
        },
        loading
      }
    }
  } = useSelector((state) => state)

  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const lastReviewRef = useInfinitScroll(loading, stats && stats.remaining, stats && stats.next_offset, setPagination, [
    loading
  ])

  useEffect(() => {
    if (pagination.isPagination) {
      dispatch(mixrActions.getMoreReviews(mixrId, pagination.nextOffset))
    }
  }, [pagination])

  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.user_id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <ul className={styles.list}>
      {reviewList.map((review, index) => {
        const isLastReview = index === reviewList.length - 1
        return (
          <li ref={isLastReview ? lastReviewRef : null} key={review.id} className={styles.listItem}>
            <div className={styles.left}>
              <Avatar
                userId={review.user_id}
                profilePicture={review.profile_picture}
                imgWrapperSize='small'
                mimeType={review.mime_type}
                originalTag={review.original_tag}
                isOriginal={review.is_original}
                onClickAction={() => showUserLightModal(review)}
              />
              <div className={styles.user}>
                <div className={styles.userData}>
                  <button
                    type='button'
                    className={styles.name}
                    onClick={() => {
                      showUserLightModal(review)
                    }}>
                    {review.displayname}
                  </button>
                  {review.review && (
                    <EmojisForRating
                      selectedValue={review.rating}
                      showEmojiText={false}
                      size='large24'
                      readOnly={true}
                    />
                  )}
                </div>
                {review.review ? (
                  <p className={styles.reviewText}>{review.review}</p>
                ) : (
                  <EmojisForRating selectedValue={review.rating} showEmojiText={false} size='large24' readOnly={true} />
                )}
              </div>
            </div>
            {review.user_id === loggedInUser?.id && (
              <div className={styles.right}>
                <IconButton iconName='edit' iconSize='large24' onClick={openWriteReviewModal} />
              </div>
            )}
          </li>
        )
      })}
      {loading && pagination.isPagination && <Spinner />}
    </ul>
  )
}

export default ReviewList
